/** A review round's status, as the round pickers show it. */
export const roundStatus: Record<string, string> = {
  open: 'In review', deciding: 'Submitting', approved: 'Approved', returned: 'Changes requested',
  superseded: 'Previous submission', published: 'Published', preparing: 'Preparing',
}

export const coachReviewStatus: Record<string, string> = {
  pending: 'Requested',
  in_progress: 'In progress',
  completed: 'Feedback received',
  failed: 'Could not finish',
  stalled: 'Taking longer than usual',
}
